import { POSTAL_CODE_FORMAT_ENDPOINT } from '@yme/common/endpoints';
import { Network } from '@yme/services/network';
export async function getPostalCodeFormat(isoCountryCode) {
    const response = await Network.get(POSTAL_CODE_FORMAT_ENDPOINT, {
        params: {
            isoCountryCode,
        },
    });
    return response.data;
}
